<template>
  <div id="shop-item" v-if="this.isexit">
    <!-- <div class="item-selector">
      <CheckButton :is-check="itemInfo.checked" @click.native="checkClick"></CheckButton>
    </div>
    <div class="item-img">
      <img :src="itemInfo.image" alt="商品图片">
    </div>
    <div class="item-info">
      <div class="item-title">{{itemInfo.title}}</div>
      <div class="item-desc">商品描述: {{itemInfo.desc}}</div>
      <div class="info-bottom">
        <div class="item-price left">¥{{itemInfo.price}}</div>
        <div class="item-count right">x{{itemInfo.count}}</div>
      </div>
    </div>
  </div> -->
  <van-swipe-cell>
  <van-card
    :num="itemInfo.count"
    :price="itemInfo.price"
    :desc="itemInfo.desc"
    :title="itemInfo.title"
    class="goods-card"
    :thumb="itemInfo.image"
  />
  <template #right>
    <van-button square text="删除" type="danger" class="delete-button" @click="remove"/>
  </template>
</van-swipe-cell>
  </div>
</template>

<script>
import CheckButton from "@/components/content/CheckButton/CheckButton";

  export default {
    name: "CartListItem",
    components: {
      CheckButton
    },
    data(){
      return {
        isexit:true
      }
    },
    props:{
      itemInfo:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    methods:{
      remove(){
        this.$store.commit('REMOVE_TO_DATA',this.itemInfo.iid)
        this.isexit=false
      }
    }
  }
</script>

<style scoped>
  #shop-item {
    width: 100%;
    display: flex;
    font-size: 0;
    padding: 5px;
    border-bottom: 1px solid #ccc;
  }

  .item-selector {
    width: 14%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .item-title, .item-desc {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-img {
    padding: 5px;
    /*border: 1px solid #ccc;*/
  }

  .item-img img {
    width: 80px;
    height: 100px;
    display: block;
    border-radius: 5px;
  }

  .item-info {
    font-size: 17px;
    color: #333;
    padding: 5px 10px;
    position: relative;
    overflow: hidden;
  }

  .item-info .item-desc {
    font-size: 14px;
    color: #666;
    margin-top: 15px;
  }

  .info-bottom {
    margin-top: 10px;
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
  }

  .info-bottom .item-price {
    color: orangered;
  }
     .goods-card {
    margin: 0;
    background-color: #fff;
  }

  .delete-button {
    height: 100%;
  }
</style>
